<template>
  <div class="template-detail__header">
    <!-- template control -->
    <div v-if="!isMobile" class="template-detail__header-control">
      <!-- back link -->
      <AppRouterLink exact :to="{ name: 'templates-listing' }" text="Salir">
        <AppIcon icon="far fa-angle-left" />
      </AppRouterLink>
      <!-- template edit status -->
      <TemplatesStatusControl :template="template" />
    </div>
    <!-- template title -->
    <div class="template-detail__header-title">
      <!-- back link mobile -->
      <AppRouterLink v-if="isMobile" exact :to="{ name: 'templates-listing' }" text="">
        <AppIcon icon="far fa-angle-left" />
      </AppRouterLink>
      <AppHeading :text="template.title">
        <TemplatesTemplateStatus compact :status="mainIsPublished ? 'published' : 'draft'" />
      </AppHeading>
    </div>
    <!-- template actions -->
    <div v-if="!isMobile" class="template-detail__header-actions">
      <!-- variant toggle -->
      <AppRouterLink
        class="template-details__actions-details"
        exact
        :to="{ name: 'template-details' }"
        text="Detalle de plantilla"
      >
        <AppIcon icon="far fa-info-square" />
      </AppRouterLink>
      <!-- publish -->
      <TemplatesPublishButton />
    </div>

    <!-- mobile menu -->
    <AppBurgerMenu v-if="isMobile" open-icon="fas fa-ellipsis-h">
      <template #menu-content>
        <TemplatesMobileMenu :template="template" variant="edit" />
      </template>
    </AppBurgerMenu>
  </div>
</template>

<script>
// Utilities
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
import TemplateStatusControl from 'Modules/Templates/mixins/statusControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppHeading from 'Ui/AppHeading'
import AppRouterLink from 'Ui/AppRouterLink'
import AppBurgerMenu from 'Ui/AppBurgerMenu'
import TemplatesMobileMenu from 'Modules/Templates/components/TemplatesMobileMenu'
import TemplatesPublishButton from 'Modules/Templates/components/TemplatesPublishButton'
import TemplatesTemplateStatus from 'Modules/Templates/components/TemplatesTemplateStatus'
import TemplatesStatusControl from 'Modules/Templates/components/TemplatesStatusControl'

export default {
  name: 'TemplateEditHeader',

  components: {
    AppIcon,
    AppHeading,
    AppRouterLink,
    AppBurgerMenu,
    TemplatesMobileMenu,
    TemplatesPublishButton,
    TemplatesTemplateStatus,
    TemplatesStatusControl,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },
  },

  mixins: [TemplateStatusControl, MobileBreakpointControl],

  data() {
    return {
      mobileBreakpoint: 900,
    }
  },
}
</script>

<style src="@/modules/Templates/assets/css/template-detail-header.css" scoped></style>
<style scoped>
.template-detail__header-title .app-heading {
  position: relative;
}

.template-detail__header-title .app-heading .template-status {
  position: absolute;
  right: -15px;
  top: -10px;
}
</style>
